import { MessageBuilder } from './message-builder';
export function defineMessage(spec) {
  var _spec$reply;
  const commonProps = {
    type: spec.type,
    replyType: (_spec$reply = spec.reply) === null || _spec$reply === void 0 ? void 0 : _spec$reply.getType()
  };
  return {
    spec,
    create: typeof spec.payloadSchema === 'undefined' ? () => new MessageBuilder(Object.assign({}, commonProps, {
      payloadSchema: undefined
    })) : payload => new MessageBuilder(Object.assign({}, commonProps, {
      payload,
      payloadSchema: spec.payloadSchema
    })),
    getType: () => spec.type
  };
}